import FullScreenPlayer from 'components/onDemand/FullScreenPlayer';
import Page404 from 'pages/404';
import { useIdleTimerContext } from 'providers/IdleTimerContext';
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';

const FullScreen: React.FC = () => {
  // section info
  const { state } = useLocation();
  const { pause, resume } = useIdleTimerContext();

  useEffect(() => {
    pause();
    return () => {
      resume();
    };
  }, [pause, resume]);

  // video info
  const match = useParams();
  const hashedId: string | undefined = match.wistiaId;
  const contentId: string | undefined = match.id;

  if (contentId && hashedId) {
    return (
      <main>
        <FullScreenPlayer
          contentId={contentId}
          hashedId={hashedId}
          sectionId={state?.sectionId ?? ''}
        />
      </main>
    );
  }
  return <Page404 />;
};

export default FullScreen;
